"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../constants");
var _dealerList = _interopRequireDefault(require("../styles/dealer-list.css"));
var _dealerAddress = _interopRequireDefault(require("./dealer/dealer-address"));
var _dealerDistance = _interopRequireDefault(require("./dealer/dealer-distance"));
var _dealerName = _interopRequireDefault(require("./dealer/dealer-name"));
var _marker = _interopRequireDefault(require("./marker"));
var _starRating = _interopRequireDefault(require("./star-rating"));
var _types = _interopRequireDefault(require("./types"));
var DealerList = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(DealerList, _React$Component);
  DealerList.dispatchCustomMouseEnterEvent = function dispatchCustomMouseEnterEvent(event, id) {
    // Custom event for mousing over the list item
    var mouseEnterListItemCustomEvent = new CustomEvent("mouseEnterListItem" + id, {
      detail: id
    });

    // dispatch custom event from document.body
    document.body.dispatchEvent(mouseEnterListItemCustomEvent);
  };
  DealerList.dispatchCustomMouseOutEvent = function dispatchCustomMouseOutEvent(event, id) {
    // Custom event for mousing out of the list item
    var mouseOutListItemCustomEvent = new CustomEvent("mouseOutListItem" + id, {
      detail: id
    });

    // dispatch custom event from document.body
    document.body.dispatchEvent(mouseOutListItemCustomEvent);
  };
  function DealerList(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;

    // Need a list of all the dealer IDs not on state
    _this.dealerIds = [];

    // Refs
    _this.dealerListItemRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  var _proto = DealerList.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var dealerList = this.props.dealerList;
    // adds dealer IDs to class instance prop;
    // needed to identify the refs to remove native nevent listeners
    if (dealerList && dealerList.length > 0) this.makeDealerIdsArray(dealerList);
  }

  // (dealerList && dealerList.length > 0)
  ;
  _proto.makeDealerIdsArray = function makeDealerIdsArray(dealerList) {
    var _this2 = this;
    // clear the array on each render
    this.dealerIds = [];

    // add dealer IDs to class instance prop array
    dealerList.forEach(function (dealer) {
      return _this2.dealerIds.push(dealer.id);
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      dealerList = _this$props.dealerList,
      _this$props$hoveredDe = _this$props.hoveredDealer,
      hoveredDealer = _this$props$hoveredDe === void 0 ? {} : _this$props$hoveredDe,
      updateSelectedDealer = _this$props.updateSelectedDealer,
      updateHoveredDealer = _this$props.updateHoveredDealer,
      mobileShowMap = _this$props.mobileShowMap,
      showRating = _this$props.showRating,
      theme = _this$props.theme,
      languageDirection = _this$props.languageDirection,
      market = _this$props.market;
    return /*#__PURE__*/_react["default"].createElement("ul", {
      className: _dealerList["default"].listOfDealers + " " + (mobileShowMap ? _dealerList["default"].hiddenContainer : '')
    }, dealerList && dealerList.length > 0 && dealerList.map(function (dealer) {
      var hoverable = hoveredDealer && hoveredDealer.id === dealer.id;
      return /*#__PURE__*/_react["default"].createElement("li", {
        onKeyPress: function onKeyPress(e) {
          e.stopPropagation();
          updateSelectedDealer(dealer);
        },
        onMouseEnter: function onMouseEnter(e) {
          DealerList.dispatchCustomMouseEnterEvent(e, dealer.id);
          updateHoveredDealer(dealer);
        },
        onFocus: function onFocus(e) {
          DealerList.dispatchCustomMouseEnterEvent(e, dealer.id);
          updateHoveredDealer(dealer);
        },
        onMouseLeave: function onMouseLeave(e) {
          DealerList.dispatchCustomMouseOutEvent(e, dealer.id);
          updateHoveredDealer(undefined);
        },
        onBlur: function onBlur(e) {
          DealerList.dispatchCustomMouseOutEvent(e, dealer.id);
          updateHoveredDealer(undefined);
        },
        key: dealer.id,
        tabIndex: 0,
        role: "link" // eslint-disable-line
        ,
        className: "\n                " + _dealerList["default"].dealerListItemLi + "\n                " + (hoveredDealer.id === dealer.id ? _dealerList["default"].hoverDealer : null) + "\n              ",
        ref: _this3.dealerListItemRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerList["default"].dealerListItemWrapper + " " + _dealerList["default"].row
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _dealerList["default"].pinMarker
      }, dealer.id && /*#__PURE__*/_react["default"].createElement(_marker["default"], {
        hoverable: hoverable,
        label: dealer.pinLabel,
        id: dealer.id,
        name: dealer.name
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _dealerList["default"].listItemFlexContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _dealerList["default"].dealerInfo
      }, /*#__PURE__*/_react["default"].createElement(_dealerName["default"], {
        theme: theme,
        name: dealer.name,
        clickHandler: updateSelectedDealer,
        dealer: dealer
      }), dealer.address && /*#__PURE__*/_react["default"].createElement(_dealerAddress["default"], {
        theme: theme,
        address: dealer.address,
        clickHandler: updateSelectedDealer,
        dealer: dealer,
        addressOrder: _constants.addressOrderMap[market]
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "" + _dealerList["default"].dealerDistance
      }, showRating && dealer.rating !== null && /*#__PURE__*/_react["default"].createElement(_starRating["default"], {
        rating: dealer.rating,
        languageDirection: languageDirection
      }), dealer.distance && /*#__PURE__*/_react["default"].createElement(_dealerDistance["default"], {
        theme: theme,
        distance: dealer.distance
      })))));
    }));
  };
  return DealerList;
}(_react["default"].Component);
exports["default"] = DealerList;
DealerList.defaultProps = {
  dealerList: []
};